import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { useOktaAuth } from "@okta/okta-react";
import { Navigate, useLocation, matchPath } from "react-router-dom";
import { useAuthUser } from "../Hooks/useAuthUser";
// ✅ This comes after imports
export const roleRouteAccessMap = JSON.parse(process.env.REACT_APP_ROLE_ROUTE_ACCESS_MAP || '{}');

const SecureRouteWrapper = ({ component: Component }) => {
  const { oktaAuth, authState } = useOktaAuth();
  const location = useLocation() || {};
  const [userGroups, setUserGroups] = useState([]);
  const [loading, setLoading] = useState(true);

  const { groups, loading: userLoading } = useAuthUser(authState, oktaAuth) || {};

  // ✅ Only update userGroups when groups change
  useEffect(() => {
    if (groups?.length > 0) {
      setUserGroups(groups);
    }
    setLoading(false); // ✅ Set local loading after data is ready
  }, [groups]);

  if (loading || !authState || userLoading) return <div>Loading...</div>;

  if (!authState?.isAuthenticated) return <Navigate to="/login" replace />;

  if (!Array.isArray(userGroups) || userGroups.length === 0) {
    return <div>🚫 Access Denied</div>;
  }

  const hasAccess = userGroups.some((group) => {
    const allowedRoutes = roleRouteAccessMap[group] || [];

    if (allowedRoutes.includes("*")) return true;

    return allowedRoutes.some((routePattern) =>
      matchPath({ path: routePattern, end: true }, location.pathname)
    );
  });

  if (!hasAccess) return <div>🚫 Access Denied</div>;

  return <Component />;
};


SecureRouteWrapper.propTypes = {
  component: PropTypes.elementType.isRequired,
};

export default SecureRouteWrapper;
